'use strict';

const isConstructor = require('../rlink-type-utils/isConstructor');
const isInstanceOf = require('../rlink-type-utils/isInstanceOf');

module.exports = function instanceOf (type, ...args) {
  let checker = (obj, key, cname, location, fullName) => {
    let value = obj[key];
    if (value !== null && value !== undefined && !isInstanceOf(value, type)) {
      return new TypeError(`Value at ${fullName} is not a ${type.name} instance.`);
    }
  };
  checker.checkerName = 'instanceOf';
  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (!isConstructor(type)) {
    throw new Error(`${checker.checkerName} check requires a constructor to check against`);
  }
  return checker;
};



// WEBPACK FOOTER //
// ./lib/rlink-shapes/instanceOf.js